import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  makeStyles,
  Box,
  IconButton,
  DialogTitle,
} from "@material-ui/core";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ReactToPrint from "react-to-print";
import { forwardRef, useRef } from "react";
import { useTranslate } from "react-admin";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import * as htmlToImage from "html-to-image";

import Receipt from "./Receipt";
import ZoomInIcon from "../../../assets/icons/zoomin.png";
import ZoomOutIcon from "../../../assets/icons/zoomout.png";
import DialogCloseButton from "../../../components/DialogCloseButton";
const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: 667,
    height: 508,
    margin: "auto",
  },
  title: {
    fontSize: 30,
    color: "#b00020",
  },
  paper: {
    margin: 0,
    width: 667,
    height: 580,
    maxWidth: 667,
    maxHeight: 580,
    minHeight: 580,
    borderRadius: 12,
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    padding: 10,
    alignItems: "center",
  },
  icon: {
    width: 19,
    height: 19,
  },
  receiptandControlContainer: {
    display: "grid",
    gridTemplateColumns: "80px auto 80px",
  },
  gridCenter: {
    justifySelf: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  dialogAction: { padding: 0 },
  button: {
    height: 69,
    minHeight: 69,
    fontSize: 26,
    borderRadius: "0px 0px",
  },
}));

const ReceiptDialog = ({
  open,
  onClose,
  receipt,
  payment,
  paymentTransaction,
  isCI = false,
}) => {
  const classes = useStyles();
  const receiptRef = useRef();
  const translate = useTranslate();
  const print = () => {};

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      classes={{ root: classes.allContainer, paper: classes.paper }}
    >
      <DialogTitle>
        <DialogCloseButton onClose={onClose} />
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <ReceiptWrapper
          ref={receiptRef}
          isCI={isCI}
          payment={payment}
          paymentTransaction={paymentTransaction}
          receipt={receipt}
        />
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <ReactToPrint
          trigger={() => (
            <Button
              onClick={() => print}
              color="primary"
              fullWidth
              variant="contained"
              classes={{ contained: classes.button }}
              disabled={false}
            >
              {translate("ra.text.paymentSuccess.printReceipt")}
            </Button>
          )}
          content={() => receiptRef.current}
        />
      </DialogActions>
    </Dialog>
  );
};

const ReceiptWrapper = forwardRef(
  ({ receipt, payment, paymentTransaction, isCI }, ref) => {
    const classes = useStyles();
    return (
      <TransformWrapper>
        {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
          <Box className={classes.receiptandControlContainer}>
            <Box></Box>
            <Box border={1}>
              <TransformComponent
                className={[classes.gridCenter, classes.border]}
              >
                <Receipt
                  isCI={isCI}
                  ref={ref}
                  receipt={receipt}
                  payment={payment}
                  paymentTransaction={paymentTransaction}
                />
              </TransformComponent>
            </Box>
            <Box className={classes.gridCenter}>
              <IconButton variant="outlined" onClick={zoomIn}>
                <img src={ZoomInIcon} className={classes.icon} alt="zoomin" />
              </IconButton>
              <IconButton variant="outlined" onClick={zoomOut}>
                <img src={ZoomOutIcon} className={classes.icon} alt="zoomout" />
              </IconButton>
              <Button variant="outlined" onClick={resetTransform}>
                Reset
              </Button>
              <IconButton
                variant="outlined"
                onClick={() => {
                  // const r = document.getElementById("saveme");
                  // console.log(r);
                  // html2canvas(r).then((canvas) => {
                  //   console.log(canvas);
                  //   canvas.style.display = "none";
                  //   var image = canvas.toDataURL("png");
                  //   var a = document.createElement("a");
                  //   a.setAttribute("download", "myImage.png");
                  //   a.setAttribute("href", image);
                  //   a.click();
                  // });
                  // exportComponentAsPNG(ref, { fileName: receipt.id + ".png" });
                  resetTransform(0);

                  setTimeout(() => {
                    htmlToImage
                      .toJpeg(document.getElementById("saveme"), {
                        quality: 1,
                      })
                      .then(() => {
                        htmlToImage
                          .toJpeg(document.getElementById("saveme"), {
                            quality: 1,
                          })
                          .then(() => {
                            htmlToImage
                              .toJpeg(document.getElementById("saveme"), {
                                quality: 1,
                              })
                              .then((dataUrl) => {
                                const link = document.createElement("a");
                                link.download = "file-name.jpeg";
                                link.href = dataUrl;
                                link.click();
                              });
                          });
                      })
                      .catch((error) => {
                        console.error("oops, something went wrong!", error);
                        alert("Ooops! Something went wrong. Try again.");
                      });

                    // htmlToImage
                    //   .toSvg(document.getElementById("saveme"), {
                    //     useCORS: true,
                    //     scale: 1,
                    //   })
                    //   .then(function (dataUrl) {
                    //     saveAs(dataUrl, "my-node.png");
                    //   });
                    // exportComponentAsJPEG(ref, {
                    //   fileName: receipt.id + ".jpg",
                    // });
                  }, 500);
                }}
              >
                <SaveAltIcon className={classes.icon} />
              </IconButton>
            </Box>
          </Box>
        )}
      </TransformWrapper>
    );
  }
);
const saveAs = (blob, fileName) => {
  var elem = window.document.createElement("a");
  elem.href = blob;
  elem.download = fileName;
  elem.style = "display:none;";
  (document.body || document.documentElement).appendChild(elem);
  if (typeof elem.click === "function") {
    elem.click();
  } else {
    elem.target = "_blank";
    elem.dispatchEvent(
      new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true,
      })
    );
  }
  URL.revokeObjectURL(elem.href);
  elem.remove();
};
export default ReceiptDialog;
export { ReceiptWrapper };
